<div class="flex justify-content-center" *ngIf="!api.fromGuard && api.pro && !api.adminOrder">
	<div class="fadeinright pt-5 md:w-30rem max-w-full">	
		<div class="p-2">	
			<h1 class="text-center text-primary">Mon Espace Pro</h1>
			<p-message styleClass="w-full" severity="error" text="{{mess}}" *ngIf="mess"></p-message>
			<div class="mt-3 text-white">
				<form #loginForm="ngForm">
					<label for="email1" class="block mb-2">Email</label>
					<input id="email1" name="email" type="email" pInputText class="w-full mb-3" [(ngModel)]="form.email" required>

					<ng-container *ngIf="!forgot">
						<label for="password1" class="block  mb-2">Mot de passe</label>
						<input id="password1" name="password" type="password" pInputText class="w-full mb-3" [(ngModel)]="form.password" required>
					</ng-container>

					<div class="flex align-items-center justify-content-between mb-6 flex-column sm:flex-row" *ngIf="!forgot">
						<div class="flex align-items-center" >
							<p-checkbox name="remember" id="rememberme1" [binary]="true" styleClass="mr-2" [(ngModel)]="form.remember"></p-checkbox>
							<label for="rememberme1" class="" >Se souvenir de moi</label>
						</div>
						<a (click)="forgot = true;mess=undefined" class="font-medium no-underline ml-2 text-500 text-right cursor-pointer">
							<u>Mot de passe oublié</u><br/><u>Première connexion</u>
						</a>
					</div>

					<div class="flex align-items-center justify-content-between mb-6" *ngIf="forgot">
						<a (click)="forgot = false;" class="font-medium no-underline ml-2 text-500 text-right cursor-pointer"><u>Retour à la connexion</u></a>
					</div>
				</form>

				<button [disabled]="loginForm.invalid" *ngIf="!forgot" pButton pRipple label="Me connecter" icon="pi pi-user" class="w-full " (click)="send()"></button>
				<div *ngIf="forgot">
					<div class="mb-4" *ngIf="customers">
						<p-message *ngIf="customers.length > 0" styleClass="w-full" severity="info" text="Cliquez sur le compte pour lequel vous souhaitez modifier le mot de passe"></p-message>
						<p-message *ngIf="customers.length === 0" styleClass="w-full" severity="error" text="Cette adresse est inconnue. Merci de contacter votre commercial"></p-message>
						<div *ngFor="let c of customers" class="m-2">
							<button pButton label="{{c.Name}}" (click)="newPass(c)" class="p-button-outlined w-full" severity="secondary"></button>
						</div>
					</div>
					<button [disabled]="loginForm.invalid"  pButton pRipple label="Vérifier mon compte" icon="pi pi-lock" class="w-full " (click)="checkAddress()"></button>
				</div>
			</div>
		</div>
	</div>
</div>

